import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from '@angular/material/table';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Router } from "@angular/router";
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ActivatedRoute, Params } from "@angular/router";
import * as moment from "moment";
declare var $: any;

@Component({
  selector: 'app-multiple-general-voucher-import',
  templateUrl: './multiple-general-voucher-import.component.html',
  styleUrls: ['./multiple-general-voucher-import.component.scss'],
  standalone: false
})
export class MultipleGeneralVoucherImportComponent implements OnInit {
  mode: 'LoanToAccount' | 'ReceiptLoan' |
    'PaymentLoanToAccount' | 'AccountToAccount' | 'ReceiptAccountToAccount' | 'PaymentAccountToAccount' |
    'PartnerReceipt' | 'PartnerPayment' |
    'PartnerJournalLoanToAccount' | 'LoanToLoan' | 'PartnerLoanToLoan' = 'LoanToAccount';
  PartnerDebitLoanNo: any = '';
  PartnerCreditLoanNo: any = '';
  DebitLoanNo: any = '';
  CreditLoanNo: any = '';
  DebitChargesHeadId: any = '';
  CreditChargesHeadId: any = '';
  DebitAccountId: any = '';
  CreditAccountId: any = '';
  DebitBranchId: any = '';
  CreditBranchId: any = '';
  Voucher_Tag: any = 'CASH';
  accountTagDropdown: any = [];
  showSpinner: boolean = false;
  ChargesHeadDropdown: any = [];
  accountHeadDropdown: any = [];
  accountHeadDropdownBankCash: any = [];
  DRAccountId: any = '';
  Voucher_Mode_of_Payment: any = '';
  Voucher_E_Ref_No: any = '';
  Voucher_E_Transaction_Date: any = '';
  Voucher_Cheque_No: any = '';
  Voucher_Cheque_Date: any = '';
  Voucher_Cheque_Clear_Date: any = '';
  Voucher_Bank_Name: any = '';
  Account_HeadId: any = '';
  Amount: any;
  UnmatchedData: any[] = [];
  UIValidationFailed: any[] = [];
  displayedColumnsUIValidation: string[] = [];
  dataSourceUIValidation: any;
  //VoucherDate: any;
  ToDate = new Date();
  Type: any = "CR"
  UnmatcheddisplayedColumns: string[] = [];
  dataSourceUnmatched: any;
  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  voucherMasterdata: any;
  voucherDetaildata: any;
  dataSourceVoucher: any;
  displayedVoucherColumns: string[] = [];
  displayedAccountingColumns: string[] = [];
  Remarks: any;
  MainPayload: any;
  BranchesList: any = [];
  BranchId: any = '';
  voucherAdd: boolean = true;
  FyearId: any;
  maxDate: any;
  minDate: any;
  @ViewChild('bulkImportModel') bulkImportModel: any;
  @ViewChild('importFileInput') importFileInput!: ElementRef;
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private _MasterService: MasterService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private dialogService: DialogService,
    private lmsService: LmsService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    this.dataSharingService.HeaderTitle.next("Multiple General Voucher Import");
    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      //console.log("paran", this.FyearId);
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));
        })
    });
    this._MasterService.GetProductChargesHeadDropDown().subscribe((result) => {
      this.ChargesHeadDropdown = JSON.parse(JSON.stringify(result));
    });
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    if (new Date(this.currentUser.SubscriptionDate) <= new Date()) {
      this.voucherAdd = false;
    } else {
      this.voucherAdd = true;
    }
    this.Get_Acc_Accounts_OtherThan_BankCash();
    this.Get_Acc_Accounts_BankCash();
    this.getBranchesList();
    this.Get_Acc_Accounts_By_Tag();
  }
  get modalTitle(): string {
    switch (this.mode) {
      case 'AccountToAccount':
        return 'Account to Account Import';
      case 'ReceiptAccountToAccount':
        return 'Account to Account Import';
      case 'PaymentAccountToAccount':
        return 'Account to Account Import';
      case 'LoanToLoan':
        return 'Loan to Loan Import';
      case 'PartnerLoanToLoan':
        return 'Partner Loan to Partner Loan Import';
      case 'ReceiptLoan':
        return 'Receipt Loan Import';
      case 'PaymentLoanToAccount':
        return 'Payment Loan to Account Import';
      case 'PartnerReceipt':
        return 'Partner Receipt Voucher Import';
      case 'PartnerPayment':
        return 'Partner Payment Voucher Import';
      case 'PartnerJournalLoanToAccount':
        return 'Partner Journal Loan to Account Import';
      default:
        return 'Loan to Accounts Import';
    }
  }

  getBranchesList() {
    this.lmsService.GetBranches({ Emp_Id: this.currentUser.userId }).subscribe((result) => {
      this.BranchesList = JSON.parse(JSON.stringify(result));
    });
  }

  Get_Acc_Accounts_OtherThan_BankCash() {
    this.lmsService.Get_Acc_Accounts_ForJVandContra({ IsJournal: 1, isAccounting: 0, LoginUserId: this.currentUser.userId }).subscribe((res: any) => {
      this.accountHeadDropdown = res;
    });
  }
  Get_Acc_Accounts_BankCash() {
    this.lmsService.Get_Acc_Accounts_ForJVandContra({ IsJournal: 0, isAccounting: 1, LoginUserId: this.currentUser.userId }).subscribe((res: any) => {
      this.accountHeadDropdownBankCash = res;
    });
  }

  Get_Acc_Accounts_By_Tag() {
    this.lmsService
      .Get_Acc_Accounts_By_Tag({
        LoginUserId: this.currentUser.userId,
        Account_Tag: this.Voucher_Tag,
        // Voucher_Date: this.VoucherDate || new Date(),
      })
      .subscribe((res: any) => {
        this.accountTagDropdown = res;
      });
  }

  // ======================= EXPORT EXCEL =======================
  exportExcel(mode: 'LoanToAccount' | 'ReceiptLoan' | 'PaymentLoanToAccount' | 'PartnerReceipt' | 'PartnerPayment' | 'PartnerJournalLoanToAccount' | 'AccountToAccount' | 'LoanToLoan' | 'PartnerLoanToLoan' | 'ReceiptAccountToAccount' | 'PaymentAccountToAccount') {
    this.mode = mode;

    // Add PartnerLoanToLoan export template
    if (mode === 'PartnerLoanToLoan') {
      const workbook = new ExcelJS.Workbook();
      const sheet1 = workbook.addWorksheet('Sheet1');

      // Show Partner specific headers
      sheet1.addRow(['PartnerDebitLoanNo', 'PartnerCreditLoanNo', 'Amount', 'DebitChargesHead', 'CreditChargesHead', 'Voucher_Narration', 'Voucher_Day', 'Voucher_Month', 'Voucher_Year']);

      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Charges Head',
          error: 'Please select from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`E${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Charges Head',
          error: 'Please select from dropdown'
        };
      }

      chargesSheet.state = 'hidden';

      workbook.xlsx.writeBuffer().then((data: any) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, 'PartnerLoanToPartnerLoan_Import.xlsx');
      });
      return;
    }
    if (mode === 'LoanToLoan') {
      const workbook = new ExcelJS.Workbook();
      const sheet1 = workbook.addWorksheet('Sheet1');

      sheet1.addRow(['DebitLoanNo', 'CreditLoanNo', 'Amount', 'DebitChargesHead', 'CreditChargesHead', 'Voucher_Narration', 'Voucher_Day', 'Voucher_Month', 'Voucher_Year']);

      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Charges Head',
          error: 'Please select from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`E${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Charges Head',
          error: 'Please select from dropdown'
        };
      }

      chargesSheet.state = 'hidden';

      workbook.xlsx.writeBuffer().then((data: any) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, 'LoanToLoan_Import.xlsx');
      });
      return;
    }

    if (mode === 'AccountToAccount') {
      const workbook = new ExcelJS.Workbook();
      const sheet1 = workbook.addWorksheet('Sheet1');

      sheet1.addRow(['DebitAccount', 'CreditAccount', 'DebitBranch', 'CreditBranch', 'Amount', 'Voucher_Narration', 'Voucher_Day', 'Voucher_Month', 'Voucher_Year']);

      const accountSheet = workbook.addWorksheet('Accounts');
      accountSheet.addRow(['Account Name', 'AccountId']);
      this.accountHeadDropdown.forEach((item: any) => {
        accountSheet.addRow([item.Account_Name, item.AccountId]);
      });

      const branchSheet = workbook.addWorksheet('Branches');
      branchSheet.addRow(['Branch Name', 'BranchId']);
      this.BranchesList.forEach((branch: any) => {
        branchSheet.addRow([branch.Branch_Name, branch.BranchId]);
      });

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`A${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Accounts!$A$2:$A$${this.accountHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Account',
          error: 'Please select Account Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`B${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Accounts!$A$2:$A$${this.accountHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Account',
          error: 'Please select Account Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$A$2:$A$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Branch',
          error: 'Please select Branch Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$A$2:$A$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Branch',
          error: 'Please select Branch Name from dropdown'
        };
      }

      accountSheet.state = 'hidden';
      branchSheet.state = 'hidden';

      workbook.xlsx.writeBuffer().then((data: any) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, 'AccountToAccount_Import.xlsx');
      });
      return;
    }
    if (mode === 'ReceiptAccountToAccount') {
      const workbook = new ExcelJS.Workbook();
      const sheet1 = workbook.addWorksheet('Sheet1');

      sheet1.addRow(['DebitAccount', 'CreditAccount', 'DebitBranch', 'CreditBranch', 'Amount', 'Voucher_Narration', 'Voucher_Day', 'Voucher_Month', 'Voucher_Year']);

      const accountSheet = workbook.addWorksheet('Accounts');
      accountSheet.addRow(['Account Name', 'AccountId']);
      this.accountHeadDropdown.forEach((item: any) => {
        accountSheet.addRow([item.Account_Name, item.AccountId]);
      });
      const bankcashaccountSheet = workbook.addWorksheet('AccountsBankCash');
      bankcashaccountSheet.addRow(['Account Name', 'AccountId']);
      this.accountHeadDropdownBankCash.forEach((item: any) => {
        bankcashaccountSheet.addRow([item.Account_Name, item.AccountId]);
      });

      const branchSheet = workbook.addWorksheet('Branches');
      branchSheet.addRow(['Branch Name', 'BranchId']);
      this.BranchesList.forEach((branch: any) => {
        branchSheet.addRow([branch.Branch_Name, branch.BranchId]);
      });

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`A${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`AccountsBankCash!$A$2:$A$${this.accountHeadDropdownBankCash.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Account',
          error: 'Please select Account Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`B${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Accounts!$A$2:$A$${this.accountHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Account',
          error: 'Please select Account Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$A$2:$A$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Branch',
          error: 'Please select Branch Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$A$2:$A$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Branch',
          error: 'Please select Branch Name from dropdown'
        };
      }

      accountSheet.state = 'hidden';
      branchSheet.state = 'hidden';
      bankcashaccountSheet.state = 'hidden';

      workbook.xlsx.writeBuffer().then((data: any) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, 'ReceiptAccountToAccount_Import.xlsx');
      });
      return;
    }
    if (mode === 'PaymentAccountToAccount') {
      const workbook = new ExcelJS.Workbook();
      const sheet1 = workbook.addWorksheet('Sheet1');

      sheet1.addRow(['DebitAccount', 'CreditAccount', 'DebitBranch', 'CreditBranch', 'Amount', 'Voucher_Narration', 'Voucher_Day', 'Voucher_Month', 'Voucher_Year']);

      const accountSheet = workbook.addWorksheet('Accounts');
      accountSheet.addRow(['Account Name', 'AccountId']);
      this.accountHeadDropdown.forEach((item: any) => {
        accountSheet.addRow([item.Account_Name, item.AccountId]);
      });
      const bankcashaccountSheet = workbook.addWorksheet('AccountsBankCash');
      bankcashaccountSheet.addRow(['Account Name', 'AccountId']);
      this.accountHeadDropdownBankCash.forEach((item: any) => {
        bankcashaccountSheet.addRow([item.Account_Name, item.AccountId]);
      });

      const branchSheet = workbook.addWorksheet('Branches');
      branchSheet.addRow(['Branch Name', 'BranchId']);
      this.BranchesList.forEach((branch: any) => {
        branchSheet.addRow([branch.Branch_Name, branch.BranchId]);
      });

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`A${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Accounts!$A$2:$A$${this.accountHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Account',
          error: 'Please select Account Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`B${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`AccountsBankCash!$A$2:$A$${this.accountHeadDropdownBankCash.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Account',
          error: 'Please select Account Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$A$2:$A$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Debit Branch',
          error: 'Please select Branch Name from dropdown'
        };
      }

      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$A$2:$A$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Credit Branch',
          error: 'Please select Branch Name from dropdown'
        };
      }

      accountSheet.state = 'hidden';
      branchSheet.state = 'hidden';
      bankcashaccountSheet.state = 'hidden';

      workbook.xlsx.writeBuffer().then((data: any) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, 'PaymentAccountToAccount_Import.xlsx');
      });
      return;
    }
    if (!this.ChargesHeadDropdown || this.ChargesHeadDropdown.length === 0) {
      this.snackBar.open('Charges Head not loaded yet!', 'Close', { duration: 3000 });
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet1 = workbook.addWorksheet('Sheet1');
    if (mode === 'PaymentLoanToAccount' || mode === 'ReceiptLoan' || mode === 'PartnerReceipt' || mode === 'PartnerPayment') {
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      sheet1.addRow(['LoanNo', 'Amount', 'ChargesHeadId', 'PaymentMode', 'RefNo', 'Voucher_Narration', 'Voucher_Day', 'Voucher_Month', 'Voucher_Year']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Charges Head',
          error: 'Please select from dropdown'
        };
      }
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"CASH,Bank,Cheque,RTGS,NEFT,IMPS,Transfer"'],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Payment Mode',
          error: 'Please select a valid mode'
        };
      }
      chargesSheet.state = 'hidden';
    }
    else {
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      sheet1.addRow(['LoanNo', 'Amount', 'ChargesHeadId', 'Voucher_Narration', 'Voucher_Day', 'Voucher_Month', 'Voucher_Year']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      let fileName = '';
      if (mode === 'ReceiptLoan') fileName = 'ReceiptLoan_Import.xlsx';
      else if (mode === 'PaymentLoanToAccount') fileName = 'PaymentLoanToAccount_Import.xlsx';
      else if (mode === 'PartnerReceipt') fileName = 'PartnerReceipt_Import.xlsx';
      else if (mode === 'PartnerPayment') fileName = 'PartnerPayment_Import.xlsx';
      else if (mode === 'PartnerJournalLoanToAccount') fileName = 'PartnerJournalLoanToAccount_Import.xlsx';
      else fileName = 'GeneralVoucher_Import.xlsx';
      saveAs(blob, fileName);
    });
  }
  OpenModel(mode: 'LoanToAccount' | 'ReceiptLoan' | 'PaymentLoanToAccount' | 'PartnerReceipt' | 'PartnerPayment' | 'PartnerJournalLoanToAccount' | 'AccountToAccount' | 'LoanToLoan' | 'PartnerLoanToLoan' | 'ReceiptAccountToAccount' | 'PaymentAccountToAccount') {
    this.mode = mode;
    this.resetValidation();
    // this.VoucherDate = null;
    this.Remarks = '';
    this.BranchId = '';
    this.Voucher_Tag = '';
    this.DRAccountId = '';
    this.Voucher_Mode_of_Payment = '';
    this.Voucher_Cheque_No = '';
    this.Voucher_Cheque_Date = null;
    this.Voucher_Cheque_Clear_Date = null;
    this.Voucher_Bank_Name = '';
    this.Voucher_E_Ref_No = '';
    this.Voucher_E_Transaction_Date = null;

    this.DebitAccountId = '';
    this.CreditAccountId = '';
    this.DebitBranchId = '';
    this.CreditBranchId = '';
    this.DebitLoanNo = '';
    this.CreditLoanNo = '';
    this.DebitChargesHeadId = '';
    this.CreditChargesHeadId = '';
    this.PartnerDebitLoanNo = '';
    this.PartnerCreditLoanNo = '';

    if (mode === 'LoanToAccount' || mode === 'PartnerJournalLoanToAccount') {
      this.Account_HeadId = '';
      this.Type = 'CR';
      this.BranchId = '';
    }

    $("#bulkImportModel").modal("show");
    $("#bulkImportModel").css("z-index", "1050");
  }
  onClose() {
    $("#bulkImportModel").modal("hide");
  }

  private matchChargesHead(chargesHeadName: any): any {
    if (!this.ChargesHeadDropdown || this.ChargesHeadDropdown.length === 0) return null;
    const normalize = (s: any) => s?.toString().trim().toLowerCase().replace(/\s+/g, ' ') || '';
    const rawHeadStr = chargesHeadName?.toString().trim() || '';

    if (rawHeadStr) {
      const found = this.ChargesHeadDropdown.find((x: any) => {
        const name = x.ChagesHead || x.ChargesHead || x.ChargesHeadName || x.Charge_Head_Name || x.Name || '';
        return normalize(name) === normalize(rawHeadStr) || String(x.Id) === rawHeadStr;
      });
      if (found) return found;
    }

    // Default fallback if charges head is empty in Excel
    const def = this.ChargesHeadDropdown.find((x: any) => {
      const name = (x.ChagesHead || x.ChargesHead || x.Name || '').toLowerCase();
      return name.includes('installment') || name.includes('principal') || name.includes('emi') || name.includes('receipt');
    }) || this.ChargesHeadDropdown[0];

    return def || null;
  }

  // ======================= IMPORT EXCEL =======================
  async importExcel(event: any) {
    this.resetValidation();

    const file = event.target.files[0];
    if (!file) return;

    if (!this.ChargesHeadDropdown || this.ChargesHeadDropdown.length === 0) {
      try {
        const result = await this._MasterService.GetProductChargesHeadDropDown().toPromise();
        this.ChargesHeadDropdown = JSON.parse(JSON.stringify(result));
      } catch (e) {
        console.error('Could not load charges head dropdown', e);
      }
    }

    const workbook = new ExcelJS.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    const sheet = workbook.getWorksheet('Sheet1');
    if (!sheet) {
      this.snackBar.open('Sheet1 not found!', 'Close', { duration: 3000 });
      return;
    }

    let rawData: any[] = [];

    // Add PartnerLoanToLoan parsing
    if (this.mode === 'PartnerLoanToLoan') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;

        const partnerDebitLoanNo = row.getCell(1)?.value?.toString().trim() || '';
        const partnerCreditLoanNo = row.getCell(2)?.value?.toString().trim() || '';
        const amount = row.getCell(3).value;
        const debitChargesHeadName = row.getCell(4)?.value?.toString().trim() || '';
        const creditChargesHeadName = row.getCell(5)?.value?.toString().trim() || '';
        const narration = row.getCell(6)?.value?.toString().trim() || '';
        const voucherDay = row.getCell(7)?.value;
        const voucherMonth = row.getCell(8)?.value;
        const voucherYear = row.getCell(9)?.value;
        if (!partnerDebitLoanNo && !partnerCreditLoanNo && !amount && !debitChargesHeadName && !creditChargesHeadName) return;

        const debitChargesHead = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim().toLowerCase() === debitChargesHeadName.toLowerCase()
        );
        const creditChargesHead = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim().toLowerCase() === creditChargesHeadName.toLowerCase()
        );

        const rowData: any = {
          Id: rawData.length + 1,
          PartnerDebitLoanNo: partnerDebitLoanNo,
          PartnerCreditLoanNo: partnerCreditLoanNo,
          DebitLoanNo: partnerDebitLoanNo,  // Map to DebitLoanNo for API
          CreditLoanNo: partnerCreditLoanNo, // Map to CreditLoanNo for API
          Amount: String(amount || '').trim(),
          DebitChargesHeadName: debitChargesHeadName,
          DebitChargesHeadId: debitChargesHead ? debitChargesHead.Id : null,
          CreditChargesHeadName: creditChargesHeadName,
          CreditChargesHeadId: creditChargesHead ? creditChargesHead.Id : null,
          Voucher_Narration: narration,
          Voucher_Day: voucherDay,
          Voucher_Month: voucherMonth,
          Voucher_Year: voucherYear
        };
        rawData.push(rowData);
      });
    } else if (this.mode === 'LoanToLoan') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;

        const debitLoanNo = row.getCell(1)?.value?.toString().trim() || '';
        const creditLoanNo = row.getCell(2)?.value?.toString().trim() || '';
        const amount = row.getCell(3).value;
        const debitChargesHeadName = row.getCell(4)?.value?.toString().trim() || '';
        const creditChargesHeadName = row.getCell(5)?.value?.toString().trim() || '';
        const narration = row.getCell(6)?.value?.toString().trim() || '';
        const voucherDay = row.getCell(7)?.value;
        const voucherMonth = row.getCell(8)?.value;
        const voucherYear = row.getCell(9)?.value;
        if (!debitLoanNo && !creditLoanNo && !amount && !debitChargesHeadName && !creditChargesHeadName) return;

        const debitChargesHead = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim().toLowerCase() === debitChargesHeadName.toLowerCase()
        );
        const creditChargesHead = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim().toLowerCase() === creditChargesHeadName.toLowerCase()
        );

        const rowData: any = {
          Id: rawData.length + 1,
          DebitLoanNo: debitLoanNo,
          CreditLoanNo: creditLoanNo,
          Amount: String(amount || '').trim(),
          DebitChargesHeadName: debitChargesHeadName,
          DebitChargesHeadId: debitChargesHead ? debitChargesHead.Id : null,
          CreditChargesHeadName: creditChargesHeadName,
          CreditChargesHeadId: creditChargesHead ? creditChargesHead.Id : null,
          Voucher_Narration: narration,
          Voucher_Day: voucherDay,
          Voucher_Month: voucherMonth,
          Voucher_Year: voucherYear
        };
        rawData.push(rowData);
      });
    }
    else if (this.mode === 'AccountToAccount') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;

        const normalize = (s: string) => s.toString().trim().replace(/\s+/g, ' ').toLowerCase();

        const debitAccountName = row.getCell(1)?.value?.toString().trim() || '';
        const creditAccountName = row.getCell(2)?.value?.toString().trim() || '';
        const debitBranchName = row.getCell(3)?.value?.toString().trim() || '';
        const creditBranchName = row.getCell(4)?.value?.toString().trim() || '';
        const amount = row.getCell(5).value;
        const narration = row.getCell(6)?.value?.toString().trim() || '';
        const voucherDay = row.getCell(7)?.value;
        const voucherMonth = row.getCell(8)?.value;
        const voucherYear = row.getCell(9)?.value;

        if (!amount && !debitAccountName && !creditAccountName && !debitBranchName && !creditBranchName) return;

        // const debitAccount = this.accountHeadDropdown.find(
        //   (x: any) => x.Account_Name?.toString().trim().toLowerCase() === debitAccountName.toLowerCase()
        // );
        const debitAccount = this.accountHeadDropdown.find(
          (x: any) => normalize(x.Account_Name) === normalize(debitAccountName)
        );
        const creditAccount = this.accountHeadDropdown.find(
          (x: any) => x.Account_Name?.toString().trim().toLowerCase() === creditAccountName.toLowerCase()
        );

        const debitBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === debitBranchName.toLowerCase()
        );
        const creditBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === creditBranchName.toLowerCase()
        );

        const rowData: any = {
          Id: rawData.length + 1,
          DebitAccountName: debitAccountName,
          DebitAccountId: debitAccount ? debitAccount.AccountId : null,
          CreditAccountName: creditAccountName,
          CreditAccountId: creditAccount ? creditAccount.AccountId : null,
          DebitBranchName: debitBranchName,
          DebitBranchId: debitBranch ? debitBranch.BranchId : null,
          CreditBranchName: creditBranchName,
          CreditBranchId: creditBranch ? creditBranch.BranchId : null,
          Amount: String(amount || '').trim(),
          Voucher_Narration: narration,
          Voucher_Day: voucherDay,
          Voucher_Month: voucherMonth,
          Voucher_Year: voucherYear
        };
        rawData.push(rowData);
      });
    }
    else if (this.mode === 'ReceiptAccountToAccount') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;

        const debitAccountName = row.getCell(1)?.value?.toString().trim() || '';
        const creditAccountName = row.getCell(2)?.value?.toString().trim() || '';
        const debitBranchName = row.getCell(3)?.value?.toString().trim() || '';
        const creditBranchName = row.getCell(4)?.value?.toString().trim() || '';
        const amount = row.getCell(5).value;
        const narration = row.getCell(6)?.value?.toString().trim() || '';
        const voucherDay = row.getCell(7)?.value;
        const voucherMonth = row.getCell(8)?.value;
        const voucherYear = row.getCell(9)?.value;

        if (!amount && !debitAccountName && !creditAccountName && !debitBranchName && !creditBranchName) return;

        const debitAccount = this.accountHeadDropdownBankCash.find(
          (x: any) => x.Account_Name?.toString().trim().toLowerCase() === debitAccountName.toLowerCase()
        );
        const creditAccount = this.accountHeadDropdown.find(
          (x: any) => x.Account_Name?.toString().trim().toLowerCase() === creditAccountName.toLowerCase()
        );

        const debitBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === debitBranchName.toLowerCase()
        );
        const creditBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === creditBranchName.toLowerCase()
        );

        const rowData: any = {
          Id: rawData.length + 1,
          DebitAccountName: debitAccountName,
          DebitAccountId: debitAccount ? debitAccount.AccountId : null,
          CreditAccountName: creditAccountName,
          CreditAccountId: creditAccount ? creditAccount.AccountId : null,
          DebitBranchName: debitBranchName,
          DebitBranchId: debitBranch ? debitBranch.BranchId : null,
          CreditBranchName: creditBranchName,
          CreditBranchId: creditBranch ? creditBranch.BranchId : null,
          Amount: String(amount || '').trim(),
          Voucher_Narration: narration,
          Voucher_Day: voucherDay,
          Voucher_Month: voucherMonth,
          Voucher_Year: voucherYear,
          GroupTag: debitAccount?.GroupTag || ''
        };
        rawData.push(rowData);
      });
    }
    else if (this.mode === 'PaymentAccountToAccount') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;

        const debitAccountName = row.getCell(1)?.value?.toString().trim() || '';
        const creditAccountName = row.getCell(2)?.value?.toString().trim() || '';
        const debitBranchName = row.getCell(3)?.value?.toString().trim() || '';
        const creditBranchName = row.getCell(4)?.value?.toString().trim() || '';
        const amount = row.getCell(5).value;
        const narration = row.getCell(6)?.value?.toString().trim() || '';
        const voucherDay = row.getCell(7)?.value;
        const voucherMonth = row.getCell(8)?.value;
        const voucherYear = row.getCell(9)?.value;

        if (!amount && !debitAccountName && !creditAccountName && !debitBranchName && !creditBranchName) return;

        const debitAccount = this.accountHeadDropdown.find(
          (x: any) => x.Account_Name?.toString().trim().toLowerCase() === debitAccountName.toLowerCase()
        );
        const creditAccount = this.accountHeadDropdownBankCash.find(
          (x: any) => x.Account_Name?.toString().trim().toLowerCase() === creditAccountName.toLowerCase()
        );

        const debitBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === debitBranchName.toLowerCase()
        );
        const creditBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === creditBranchName.toLowerCase()
        );

        const rowData: any = {
          Id: rawData.length + 1,
          DebitAccountName: debitAccountName,
          DebitAccountId: debitAccount ? debitAccount.AccountId : null,
          CreditAccountName: creditAccountName,
          CreditAccountId: creditAccount ? creditAccount.AccountId : null,
          DebitBranchName: debitBranchName,
          DebitBranchId: debitBranch ? debitBranch.BranchId : null,
          CreditBranchName: creditBranchName,
          CreditBranchId: creditBranch ? creditBranch.BranchId : null,
          Amount: String(amount || '').trim(),
          Voucher_Narration: narration,
          Voucher_Day: voucherDay,
          Voucher_Month: voucherMonth,
          Voucher_Year: voucherYear,
          GroupTag: creditAccount?.GroupTag || ''
        };
        rawData.push(rowData);
      });
    }
    else if (this.mode === 'ReceiptLoan' || this.mode === 'PaymentLoanToAccount' ||
      this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const loanNo = row.getCell(1).value?.toString().trim() || '';
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;
        const paymentMode = row.getCell(4)?.value?.toString().trim() || '';
        const refNo = row.getCell(5)?.value?.toString().trim() || '';
        const narration = row.getCell(6)?.value?.toString().trim() || '';
        const voucherDay = row.getCell(7)?.value;
        const voucherMonth = row.getCell(8)?.value;
        const voucherYear = row.getCell(9)?.value;

        if (!loanNo && !amount && !chargesHeadName && !paymentMode && !refNo && !narration) return;

        const matched = this.matchChargesHead(chargesHeadName);
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: loanNo,
          Amount: String(amount || '').trim(),
          ChargesHead: matched ? (matched.ChagesHead || matched.ChargesHead || String(chargesHeadName || '').trim()) : String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
          PaymentMode: paymentMode,
          RefNo: refNo,
          Voucher_Narration: narration,
          Voucher_Day: voucherDay,
          Voucher_Month: voucherMonth,
          Voucher_Year: voucherYear
        };
        rawData.push(rowData);
      });
    }
    else {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const loanNo = row.getCell(1).value;
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;
        const narration = row.getCell(4)?.value?.toString().trim() || '';
        const voucherDay = row.getCell(5)?.value;
        const voucherMonth = row.getCell(6)?.value;
        const voucherYear = row.getCell(7)?.value;
        if (!loanNo && !amount && !chargesHeadName) return;
        const matched = this.matchChargesHead(chargesHeadName);
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: String(loanNo || '').trim(),
          Amount: String(amount || '').trim(),
          ChargesHead: matched ? (matched.ChagesHead || matched.ChargesHead || String(chargesHeadName || '').trim()) : String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
          Voucher_Narration: narration,
          Voucher_Day: voucherDay,
          Voucher_Month: voucherMonth,
          Voucher_Year: voucherYear
        };
        rawData.push(rowData);
      });
    }

    if (rawData.length === 0) {
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'No data found in Excel file!', ...this.configSuccess });
      event.target.value = null;
      return;
    }

    this.UIValidationFailed = this.validateUIRows(rawData);

    if (this.UIValidationFailed.length > 0) {
      this.showUIValidationTable();
      const fileInput = document.getElementById('bulkImport') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    } else {
      this.processValidData(rawData);
    }

    event.target.value = null;
  }
  private validateUIRows(data: any[]): any[] {
    const allowedUnlimitedModes = ['PaymentLoanToAccount', 'PartnerPayment', 'AccountToAccount', 'LoanToLoan', 'PartnerLoanToLoan', 'ReceiptAccountToAccount', 'PaymentAccountToAccount'];
    if (data.length > 50 && !allowedUnlimitedModes.includes(this.mode)) {
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'Max row of data import is 50!', ...this.configSuccess });
      return data.map(row => ({
        ...row,
        maxRowLimitError: true
      }));
    }

    const failedRows: any[] = [];

    data.forEach((row) => {
      const errorFlags: any = {};

      const day = Number(row.Voucher_Day);
      const month = Number(row.Voucher_Month);
      const year = Number(row.Voucher_Year);

      const voucherDate = new Date(year, month - 1, day);

      const isValidDate =
        Number.isInteger(day) &&
        Number.isInteger(month) &&
        Number.isInteger(year) &&
        year >= 2000 && // adjust as needed
        voucherDate.getFullYear() === year &&
        voucherDate.getMonth() === month - 1 &&
        voucherDate.getDate() === day;

      if (!isValidDate) {
        errorFlags.voucherDateError = true;
      }
      if (this.ToDate >= this.maxDate) {
        this.ToDate = this.maxDate;
      }
      if (voucherDate < this.minDate || voucherDate > this.ToDate) {
        errorFlags.FinancialYearError = true;
      }
      if (this.mode === 'PartnerLoanToLoan') {
        // Validate Partner DebitLoanNo
        if (!row.PartnerDebitLoanNo || row.PartnerDebitLoanNo.trim() === '')
          errorFlags.debitLoanNoError = true;

        // Validate Partner CreditLoanNo
        if (!row.PartnerCreditLoanNo || row.PartnerCreditLoanNo.trim() === '')
          errorFlags.creditLoanNoError = true;

        // Validate Amount
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0)
          errorFlags.amountError = true;

        // Validate DebitChargesHead
        if (!row.DebitChargesHeadName || row.DebitChargesHeadName.trim() === '')
          errorFlags.debitChargesHeadError = true;
        else if (!row.DebitChargesHeadId)
          errorFlags.debitChargesHeadError = true;

        // Validate CreditChargesHead
        if (!row.CreditChargesHeadName || row.CreditChargesHeadName.trim() === '')
          errorFlags.creditChargesHeadError = true;
        else if (!row.CreditChargesHeadId)
          errorFlags.creditChargesHeadError = true;

        const isDebitValid = !errorFlags.debitLoanNoError && !errorFlags.debitChargesHeadError;
        const isCreditValid = !errorFlags.creditLoanNoError && !errorFlags.creditChargesHeadError;

        if (isDebitValid && isCreditValid) {
          const isSameLoanNo = row.PartnerDebitLoanNo.toLowerCase() === row.PartnerCreditLoanNo.toLowerCase();
          const isSameChargesHead = row.DebitChargesHeadName.toLowerCase() === row.CreditChargesHeadName.toLowerCase();

          if (isSameLoanNo && isSameChargesHead) {
            errorFlags.invalidCombinationError = true;
          }
        }
      } else if (this.mode === 'LoanToLoan') {
        if (!row.DebitLoanNo || row.DebitLoanNo.trim() === '')
          errorFlags.debitLoanNoError = true;

        if (!row.CreditLoanNo || row.CreditLoanNo.trim() === '')
          errorFlags.creditLoanNoError = true;

        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0)
          errorFlags.amountError = true;

        if (!row.DebitChargesHeadName || row.DebitChargesHeadName.trim() === '')
          errorFlags.debitChargesHeadError = true;
        else if (!row.DebitChargesHeadId)
          errorFlags.debitChargesHeadError = true;

        if (!row.CreditChargesHeadName || row.CreditChargesHeadName.trim() === '')
          errorFlags.creditChargesHeadError = true;
        else if (!row.CreditChargesHeadId)
          errorFlags.creditChargesHeadError = true;

        const isDebitValid = !errorFlags.debitLoanNoError && !errorFlags.debitChargesHeadError;
        const isCreditValid = !errorFlags.creditLoanNoError && !errorFlags.creditChargesHeadError;

        if (isDebitValid && isCreditValid) {
          const isSameLoanNo = row.DebitLoanNo.toLowerCase() === row.CreditLoanNo.toLowerCase();
          const isSameChargesHead = row.DebitChargesHeadName.toLowerCase() === row.CreditChargesHeadName.toLowerCase();

          if (isSameLoanNo && isSameChargesHead) {
            errorFlags.invalidCombinationError = true;
          }
        }
      }

      else if (this.mode === 'AccountToAccount' || this.mode === 'ReceiptAccountToAccount' || this.mode === 'PaymentAccountToAccount') {
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0)
          errorFlags.amountError = true;


        if (!row.DebitAccountName || row.DebitAccountName.trim() === '')
          errorFlags.debitAccountError = true;
        else if (!row.DebitAccountId)
          errorFlags.debitAccountError = true;

        if (!row.CreditAccountName || row.CreditAccountName.trim() === '')
          errorFlags.creditAccountError = true;
        else if (!row.CreditAccountId)
          errorFlags.creditAccountError = true;

        if (!row.DebitBranchName || row.DebitBranchName.trim() === '')
          errorFlags.debitBranchError = true;
        else if (!row.DebitBranchId)
          errorFlags.debitBranchError = true;

        if (!row.CreditBranchName || row.CreditBranchName.trim() === '')
          errorFlags.creditBranchError = true;
        else if (!row.CreditBranchId)
          errorFlags.creditBranchError = true;

        if (row.DebitAccountName && row.CreditAccountName &&
          row.DebitAccountName.toLowerCase() === row.CreditAccountName.toLowerCase())
          errorFlags.sameAccountError = true;


      }
      else if (this.mode === 'ReceiptLoan' || this.mode === 'PaymentLoanToAccount' ||
        this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
        if (!row.LoanNo || row.LoanNo.trim() === '')
          errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0)
          errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId)
          errorFlags.chargesHeadError = true;
        if (!row.PaymentMode)
          errorFlags.paymentModeError = true;
        if (row.RefNo && row.RefNo.toString().trim() !== '') {
          const refNoValue = row.RefNo.toString().trim();
          const isDuplicate = data.some((r: any, index: number) => {
            if (index === data.indexOf(row)) return false;
            const otherRefNo = r.RefNo ? r.RefNo.toString().trim() : '';
            return otherRefNo !== '' && otherRefNo.toLowerCase() === refNoValue.toLowerCase();
          });
          if (isDuplicate) {
            errorFlags.refNoDuplicateError = true;
          }
        }
      }
      else if (this.mode === 'LoanToAccount' || this.mode === 'PartnerJournalLoanToAccount') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
      }

      if (Object.keys(errorFlags).length > 0) {
        failedRows.push({ ...row, ...errorFlags });
      }
    });

    return failedRows;
  }
  private showUIValidationTable() {
    if (this.mode === 'PartnerLoanToLoan') {
      this.displayedColumnsUIValidation = ["Id", "PartnerDebitLoanNo", "PartnerCreditLoanNo", "Amount", "DebitChargesHeadName", "CreditChargesHeadName", "VoucherDate", "Voucher_Narration", "Errors"];
    } else if (this.mode === 'LoanToLoan') {
      this.displayedColumnsUIValidation = ["Id", "DebitLoanNo", "CreditLoanNo", "Amount", "DebitChargesHeadName", "CreditChargesHeadName", "VoucherDate", "Voucher_Narration", "Errors"];
    } else if (this.mode === 'AccountToAccount' || this.mode === 'ReceiptAccountToAccount' || this.mode === 'PaymentAccountToAccount') {
      this.displayedColumnsUIValidation = ["Id", "DebitAccountName", "CreditAccountName", "DebitBranchName", "CreditBranchName", "Amount", "VoucherDate", "Voucher_Narration", "Errors"];
    } else if (this.mode === 'ReceiptLoan' || this.mode === 'PartnerReceipt') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "PaymentMode", "RefNo", "VoucherDate", "Voucher_Narration", "Errors"];
    } else if (this.mode === 'LoanToAccount' || this.mode === 'PartnerJournalLoanToAccount') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "VoucherDate", "Voucher_Narration", "Errors"];
    } else if (this.mode === 'PaymentLoanToAccount' || this.mode === 'PartnerPayment') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "PaymentMode", "RefNo", "VoucherDate", "Errors"];
    }
    console.log("this.UIValidationFailed", this.UIValidationFailed);
    this.dataSourceUIValidation = new MatTableDataSource(this.UIValidationFailed);
    $("#bulkImportModel").modal("show");
  }
  private processValidData(data: any[]) {
    let JsonData: any;
    const formatLocalDate = (date: any): string => {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    // const VoucherDate = formatLocalDate(this.VoucherDate);

    if (this.mode === 'PartnerLoanToLoan') {
      const finalData = data.map(row => ({
        DebitLoanNo: row.DebitLoanNo,  // Send as DebitLoanNo to API
        CreditLoanNo: row.CreditLoanNo, // Send as CreditLoanNo to API
        Amount: Number(row.Amount),
        DebitChargesHeadId: Number(row.DebitChargesHeadId),
        CreditChargesHeadId: Number(row.CreditChargesHeadId),
        Voucher_Narration: row.Voucher_Narration,
        Voucher_Day: row.Voucher_Day,
        Voucher_Month: row.Voucher_Month,
        Voucher_Year: row.Voucher_Year,
        VoucherDate: `${row.Voucher_Year}-${String(row.Voucher_Month).padStart(2, '0')}-${String(row.Voucher_Day).padStart(2, '0')}`
      }));
      JsonData = {
        // VoucherDate: VoucherDate,
        LoanDetails: finalData
      };
    } else if (this.mode === 'LoanToLoan') {
      const finalData = data.map(row => ({
        DebitLoanNo: row.DebitLoanNo,
        CreditLoanNo: row.CreditLoanNo,
        Amount: Number(row.Amount),
        DebitChargesHeadId: Number(row.DebitChargesHeadId),
        CreditChargesHeadId: Number(row.CreditChargesHeadId),
        Voucher_Narration: row.Voucher_Narration,
        Voucher_Day: row.Voucher_Day,
        Voucher_Month: row.Voucher_Month,
        Voucher_Year: row.Voucher_Year,
        VoucherDate: `${row.Voucher_Year}-${String(row.Voucher_Month).padStart(2, '0')}-${String(row.Voucher_Day).padStart(2, '0')}`
      }));
      JsonData = {
        // VoucherDate: VoucherDate,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'AccountToAccount') {
      const finalData = data.map(row => ({
        Amount: Number(row.Amount),
        DebitAccountId: Number(row.DebitAccountId),
        CreditAccountId: Number(row.CreditAccountId),
        DebitBranchId: Number(row.DebitBranchId),
        CreditBranchId: Number(row.CreditBranchId),
        Voucher_Narration: row.Voucher_Narration,
        Voucher_Day: row.Voucher_Day,
        Voucher_Month: row.Voucher_Month,
        Voucher_Year: row.Voucher_Year,
        VoucherDate: `${row.Voucher_Year}-${String(row.Voucher_Month).padStart(2, '0')}-${String(row.Voucher_Day).padStart(2, '0')}`

      }));
      JsonData = {
        // VoucherDate: VoucherDate,
        AccountDetails: finalData
      };
    }
    else if (this.mode === 'ReceiptAccountToAccount' || this.mode === 'PaymentAccountToAccount') {
      const finalData = data.map(row => ({
        Amount: Number(row.Amount),
        DebitAccountId: Number(row.DebitAccountId),
        CreditAccountId: Number(row.CreditAccountId),
        DebitBranchId: Number(row.DebitBranchId),
        CreditBranchId: Number(row.CreditBranchId),
        Voucher_Narration: row.Voucher_Narration,
        Voucher_Day: row.Voucher_Day,
        Voucher_Month: row.Voucher_Month,
        Voucher_Year: row.Voucher_Year,
        VoucherDate: `${row.Voucher_Year}-${String(row.Voucher_Month).padStart(2, '0')}-${String(row.Voucher_Day).padStart(2, '0')}`,
        Voucher_Tag: row.GroupTag

      }));
      JsonData = {
        // VoucherDate: VoucherDate,
        AccountDetails: finalData
      };
    }
    else if (this.mode === 'ReceiptLoan' || this.mode === 'PaymentLoanToAccount' ||
      this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
        PaymentMode: row.PaymentMode,
        RefNo: row.RefNo || "",
        Voucher_Narration: row.Voucher_Narration,
        Voucher_Day: row.Voucher_Day,
        Voucher_Month: row.Voucher_Month,
        Voucher_Year: row.Voucher_Year,
        VoucherDate: `${row.Voucher_Year}-${String(row.Voucher_Month).padStart(2, '0')}-${String(row.Voucher_Day).padStart(2, '0')}`

      }));
      JsonData = {
        //VoucherDate: VoucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'LoanToAccount' || this.mode === 'PartnerJournalLoanToAccount') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
        Voucher_Narration: row.Voucher_Narration,
        Voucher_Day: row.Voucher_Day,
        Voucher_Month: row.Voucher_Month,
        Voucher_Year: row.Voucher_Year,
        VoucherDate: `${row.Voucher_Year}-${String(row.Voucher_Month).padStart(2, '0')}-${String(row.Voucher_Day).padStart(2, '0')}`

      }));
      JsonData = {
        // VoucherDate: VoucherDate,
        AccountId: Number(this.Account_HeadId),
        TransType: this.Type,
        BranchId: Number(this.BranchId),
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }

    let checkApi;
    console.log(JsonData);

    if (this.mode === 'PartnerLoanToLoan') {
      checkApi = this._MasterService.Journal_Multi_Voucher_Check_PartnerLoantoPartnerLoan_Import({
        JsonData: JSON.stringify(JsonData),
      });
    }
    else if (this.mode === 'LoanToLoan') {
      checkApi = this._MasterService.Journal_Multi_Voucher_Check_LoantoLoan_Import({
        JsonData: JSON.stringify(JsonData),
      });
    }
    else if (this.mode === 'AccountToAccount') {
      checkApi = this._MasterService.Journal_Multi_Voucher_Check_AccounttoAccount_Import({
        JsonData: JSON.stringify(JsonData),
      });
    } else if (this.mode === 'ReceiptAccountToAccount') {
      checkApi = this._MasterService.Receipt_Multi_Voucher_Check_AccounttoAccount_Import({
        JsonData: JSON.stringify(JsonData),
      });
    } else if (this.mode === 'PaymentAccountToAccount') {
      checkApi = this._MasterService.Payment_Multi_Voucher_Check_AccounttoAccount_Import({
        JsonData: JSON.stringify(JsonData),
      });
    }
    else if (this.mode === 'ReceiptLoan') {
      checkApi = this._MasterService.Receipt_Voucher_Check_LoantoAccount_Import({
        JsonData: JSON.stringify(JsonData),
        IsMultipleVoucher: 1
      });
    } else if (this.mode === 'PaymentLoanToAccount') {
      checkApi = this._MasterService.Payment_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    } else if (this.mode === 'PartnerReceipt') {
      checkApi = this._MasterService.Partner_Receipt_Voucher_Check_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    } else if (this.mode === 'PartnerPayment') {
      checkApi = this._MasterService.Partner_Payment_Voucher_Check_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      checkApi = this._MasterService.Partner_Journal_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    } else {
      checkApi = this._MasterService.Journal_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    }

    checkApi.subscribe((res: any) => {
      if (res && res.length > 0) {
        this.UnmatchedData = res.map((item: any) => ({
          ...item,
          AccountHead: item.AccountName || item.AccountHead || '',
          LoanNo: item.LoanNo || ''
        }));
        if (this.mode === 'PartnerLoanToLoan') {
          this.UnmatcheddisplayedColumns = ["Id", "PartnerDebitLoanNo", "PartnerCreditLoanNo", "ErrorReason"];
        } else if (this.mode === 'LoanToLoan') {
          this.UnmatcheddisplayedColumns = ["Id", "DebitLoanNo", "CreditLoanNo", "ErrorReason"];
        } else {
          this.UnmatcheddisplayedColumns = ["Id", "LoanNo", "ErrorReason"];
        }
        this.dataSourceUnmatched = new MatTableDataSource(this.UnmatchedData);
      } else {
        let getApi;
        if (this.mode === 'PartnerLoanToLoan') {
          getApi = this._MasterService.Journal_Multi_Voucher_Get_PartnerLoantoPartnerLoan_Import({
            JsonData: JSON.stringify(JsonData),
          });
        }
        else if (this.mode === 'LoanToLoan') {
          getApi = this._MasterService.Journal_Multi_Voucher_Get_LoantoLoan_Import({
            JsonData: JSON.stringify(JsonData),
          });
        }
        else if (this.mode === 'AccountToAccount') {
          getApi = this._MasterService.Journal_Multi_Voucher_Get_AccounttoAccount_Import({
            JsonData: JSON.stringify(JsonData),
          });
        } else if (this.mode === 'ReceiptAccountToAccount') {
          getApi = this._MasterService.Receipt_Multi_Voucher_Get_AccounttoAccount_Import({
            JsonData: JSON.stringify(JsonData),
          });
        }
        else if (this.mode === 'PaymentAccountToAccount') {
          getApi = this._MasterService.Payment_Multi_Voucher_Get_AccounttoAccount_Import({
            JsonData: JSON.stringify(JsonData),
          });
        }
        else if (this.mode === 'LoanToAccount') {
          getApi = this._MasterService.Journal_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        } else if (this.mode === 'ReceiptLoan') {
          getApi = this._MasterService.Receipt_Voucher_Get_LoantoAccount_Import({
            JsonData: JSON.stringify(JsonData),
            IsMultipleVoucher: 1
          });
        } else if (this.mode === 'PaymentLoanToAccount') {
          getApi = this._MasterService.Payment_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        } else if (this.mode === 'PartnerReceipt') {
          getApi = this._MasterService.Partner_Receipt_Voucher_Get_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        } else if (this.mode === 'PartnerPayment') {
          getApi = this._MasterService.Partner_Payment_Voucher_Get_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        } else if (this.mode === 'PartnerJournalLoanToAccount') {
          getApi = this._MasterService.Partner_Journal_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        }

        getApi.subscribe((res: any) => {
          this.voucherMasterdata = res.Item1[0];
          this.voucherDetaildata = res.Item2;

          this.voucherDetaildata.forEach((x: any) => {
            x.AmountDR = x.TranType === 'DR' ? x.Amount : 0;
            x.AmountCR = x.TranType === 'CR' ? x.Amount : 0;
          });
          this.dataSourceVoucher = new MatTableDataSource(this.voucherDetaildata);

          if (this.mode === 'AccountToAccount' || this.mode === 'ReceiptAccountToAccount' || this.mode === 'PaymentAccountToAccount') {
            this.displayedAccountingColumns = ['AccountHead', 'Branch', 'AmountDR', 'AmountCR'];
          } else {
            this.displayedVoucherColumns = [
              'Type', 'VoucherDate', 'CaseNo', 'Customer', 'Branch', 'Category', 'AccountHead', 'AmountDR', 'AmountCR'
            ];
          }

          this.MainPayload = JsonData;
          $("#voucherDetailModel").modal("show");
          $('#voucherDetailModel').css('z-index', '1051');
        });
      }
    });
  }

  OnSaveVoucher() {
    let saveApi;
    if (this.mode === 'PartnerLoanToLoan') {
      saveApi = this._MasterService.Journal_Multi_Voucher_Save_PartnerLoantoPartnerLoan_Import({
        JsonData: JSON.stringify(this.MainPayload),
        LoginUserId: this.currentUser.userId,
      });
    }
    else if (this.mode === 'LoanToLoan') {
      saveApi = this._MasterService.Journal_Multi_Voucher_Save_LoantoLoan_Import({
        JsonData: JSON.stringify(this.MainPayload),
        LoginUserId: this.currentUser.userId,
      });
    }
    else if (this.mode === 'AccountToAccount') {
      saveApi = this._MasterService.Journal_Multi_Voucher_Save_AccounttoAccount_Import({
        JsonData: JSON.stringify(this.MainPayload),
        LoginUserId: this.currentUser.userId,
      });
    }
    else if (this.mode === 'ReceiptAccountToAccount') {
      saveApi = this._MasterService.Receipt_Multi_Voucher_Save_AccounttoAccount_Import({
        JsonData: JSON.stringify(this.MainPayload),
        LoginUserId: this.currentUser.userId,
      });
    }
    else if (this.mode === 'PaymentAccountToAccount') {
      saveApi = this._MasterService.Payment_Multi_Voucher_Save_AccounttoAccount_Import({
        JsonData: JSON.stringify(this.MainPayload),
        LoginUserId: this.currentUser.userId,
      });
    }
    else if (this.mode === 'LoanToAccount') {
      saveApi = this._MasterService.Journal_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'ReceiptLoan') {
      saveApi = this._MasterService.Receipt_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'PaymentLoanToAccount') {
      saveApi = this._MasterService.Payment_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'PartnerReceipt') {
      saveApi = this._MasterService.Partner_Receipt_Voucher_Save_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'PartnerPayment') {
      saveApi = this._MasterService.Partner_Payment_Voucher_Save_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'PartnerJournalLoanToAccount') {
      saveApi = this._MasterService.Partner_Journal_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }

    saveApi.subscribe((res: any) => {
      this.OnCloseVoucher();
      this.onClose();
      this.showSpinner = true;
      if (res[0].CODE > 0) {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].Msg, ...this.configSuccess });
        this.showSpinner = false;
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].Msg, ...this.configSuccess });
        this.showSpinner = false;
      }
    });
  }

  calculateTranTypeCR() {
    if (this.voucherDetaildata) {
      let sum = 0.00;
      for (let i = 0; i < this.voucherDetaildata.length; i++) {
        sum += Number(this.voucherDetaildata[i]["AmountCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  calculateTranTypeDR() {
    if (this.voucherDetaildata) {
      let sum = 0.00;
      for (let i = 0; i < this.voucherDetaildata.length; i++) {
        sum += Number(this.voucherDetaildata[i]["AmountDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  private resetValidation() {
    this.UIValidationFailed = [];
    this.dataSourceUIValidation = new MatTableDataSource([]);
    this.dataSourceUnmatched = null;
  }

  OnCloseVoucher() {
    $("#voucherDetailModel").modal("hide");
  }
  exportVoucherToExcel(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';

    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const isLoanOrPartner =
      this.voucherMasterdata?.Voucher_Sub_Type === 'Loan' ||
      this.voucherMasterdata?.Voucher_Sub_Type === 'Partner';

    let headerRow = '';
    let bodyRows = '';

    if (isLoanOrPartner) {
      headerRow = `<tr>
      <th>Type</th><th>Voucher Date</th><th>Case No</th><th>Customer</th>
      <th>Branch</th><th>Category</th><th>Account Head</th><th>Amount(DR)</th><th>Amount(CR)</th>
    </tr>`;
      bodyRows = this.dataSourceVoucher.data
        .map((row: any) => `<tr>
        <td>${row.TranType ?? ''}</td>
        <td>${row.VoucherDate ?? ''}</td>
        <td>${row.CaseNo ?? ''}</td>
        <td>${row.Customer ?? ''}</td>
        <td>${row.Branch_Name ?? ''}</td>
        <td>${row.ChagesHead ?? ''}</td>
        <td>${row.ChargeHeadCategory ?? ''}</td>
        <td>${row.AmountDR ?? ''}</td>
        <td>${row.AmountCR ?? ''}</td>
      </tr>`)
        .join('');
    } else {
      headerRow = `<tr>
      <th>Account Head</th><th>Branch</th><th>Amount(DR)</th><th>Amount(CR)</th>
    </tr>`;
      bodyRows = this.dataSourceVoucher.data
        .map((row: any) => `<tr>
        <td>${row.ChargeHeadCategory ?? ''}</td>
        <td>${row.Branch_Name ?? ''}</td>
        <td>${row.AmountDR ?? ''}</td>
        <td>${row.AmountCR ?? ''}</td>
      </tr>`)
        .join('');
    }

    const footerRow = `<tr>
    <td colspan="${isLoanOrPartner ? 6 : 1}"><b>Total</b></td>
    <td>${this.calculateTranTypeDR()}</td>
    <td>${this.calculateTranTypeCR()}</td>
  </tr>`;

    const tableHtml = headerRow + bodyRows + footerRow;
    const worksheetName = 'Voucher Detail';
    const ctx = { worksheet: worksheetName, table: tableHtml };

    const downloadLink = document.createElement('a');
    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = worksheetName + '.xls';
    downloadLink.click();
  }

  exportErrorsToExcel() {
    const workbook = new ExcelJS.Workbook();
    const hasUIErrors = this.UIValidationFailed && this.UIValidationFailed.length > 0;
    const hasUnmatched = this.UnmatchedData && this.UnmatchedData.length > 0;

    if (!hasUIErrors && !hasUnmatched) {
      this.snackBar.open('No errors to export!', 'Close', { duration: 3000 });
      return;
    }

    if (hasUIErrors) {
      const uiSheet = workbook.addWorksheet('UI Validation Errors');
      const colHeaders: any = {
        'Id': '#', 'LoanNo': 'LoanNo', 'Amount': 'Amount', 'ChargesHead': 'Charges Head',
        'TransType': 'Trans Type', 'AccountHead': 'Account Head', 'BranchName': 'Branch',
        'DebitLoanNo': 'Debit Loan No', 'CreditLoanNo': 'Credit Loan No',
        'PartnerDebitLoanNo': 'Partner Debit Loan No', 'PartnerCreditLoanNo': 'Partner Credit Loan No',
        'DebitChargesHeadName': 'Debit Charges Head', 'CreditChargesHeadName': 'Credit Charges Head',
        'DebitAccountName': 'Debit Account', 'CreditAccountName': 'Credit Account',
        'DebitBranchName': 'Debit Branch', 'CreditBranchName': 'Credit Branch',
        'PaymentMode': 'Payment Mode', 'RefNo': 'Ref No', 'VoucherDate': 'Voucher Date',
        'Voucher_Narration': 'Voucher Narration', 'Errors': 'Error Details'
      };
      const headers = this.displayedColumnsUIValidation.map(col => colHeaders[col] || col);
      uiSheet.addRow(headers);

      this.UIValidationFailed.forEach((row: any) => {
        const rowData = this.displayedColumnsUIValidation.map(col => row[col] || '');
        uiSheet.addRow(rowData);
      });

      uiSheet.columns.forEach((col: any) => { col.width = 20; });
    }

    if (hasUnmatched) {
      const unSheet = workbook.addWorksheet('Backend Validation Errors');
      const unHeaders: any = {
        'Id': '#', 'LoanNo': 'LoanNo', 'AccountHead': 'Account Head', 'ErrorReason': 'Error Reason',
        'DebitLoanNo': 'Debit Loan No', 'CreditLoanNo': 'Credit Loan No',
        'PartnerDebitLoanNo': 'Partner Debit Loan No', 'PartnerCreditLoanNo': 'Partner Credit Loan No'
      };
      unSheet.addRow(this.UnmatcheddisplayedColumns.map(col => unHeaders[col] || col));
      this.UnmatchedData.forEach((row: any) => {
        unSheet.addRow(this.UnmatcheddisplayedColumns.map(col => row[col] || ''));
      });
      unSheet.columns.forEach((col: any) => { col.width = 25; });
    }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, 'Import_Errors_' + this.mode + '.xlsx');
    });
  }

}
